<template>
  <el-cascader
    v-model="val"
    :props="{ value: 'label', checkStrictly: false, expandTrigger: 'hover' }"
    placeholder="请选择专业或学科"
    :options="treeData"
    :show-all-levels="false"
    clearable
    filterable
  ></el-cascader>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SelectProEduTree",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    treeData: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      val: [],
    };
  },
  watch: {
    value: {
      handler(v) {
        console.log("v", v);
        this.val = [];
        if (
          v.toString().substring(0, 1) === "2" ||
          v.toString().substring(0, 1) === "3"
        ) {
          this.val.push("高等职业教育本科专业");
          this.val.push(v);
        } else if (
          v.toString().substring(0, 1) === "4" ||
          v.toString().substring(0, 1) === "5"
        ) {
          this.val.push("高等职业教育专科专业");
          this.val.push(v);
        } else if (
          v.toString().substring(0, 1) === "6" ||
          v.toString().substring(0, 1) === "7"
        ) {
          this.val.push("中等职业教育专业");
          this.val.push(v);
        } else {
          this.val.push(v);
        }
      },
      immediate: true,
    },
    val(v) {
      this.$emit("change", v[v.length - 1] || "");
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss"></style>
